import { useQuery } from '@tanstack/react-query'
import { ConfigHttpClient, ConfigResponse } from '@omnea-app/config/configHttpClient'
import { QUERY_TIME_CONFIG } from '@omnea-app/fe-api-client/queryConfig'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { GlobalIntegration } from '@omnea-app/packages/universal/integrations/globalIntegrations'
import { isDefined } from '@omnea-app/packages/universal/type-guards/isDefined'
import { organisationIntegrationsQueryKey } from './organisationIntegrationsQueryKey'

type ListOrganisationIntegrationResponseType = ConfigResponse<'/integrations', 'get'>
type ListOrganisationIntegrationsData = ListOrganisationIntegrationResponseType['data']
type ListOrganisationIntegrationsError = ListOrganisationIntegrationResponseType['error']
export type OrganisationIntegration = NonNullable<ListOrganisationIntegrationsData>[number]

export const useListOrganisationIntegrations = ({
  enabled = true,
  type,
}: { enabled?: boolean; type?: GlobalIntegration } = {}) => {
  const { getToken } = useAuthenticatedUser()

  return useQuery<ListOrganisationIntegrationsData, ListOrganisationIntegrationsError>({
    queryKey: isDefined(type) ? [organisationIntegrationsQueryKey, type] : [organisationIntegrationsQueryKey],
    enabled,
    staleTime: QUERY_TIME_CONFIG.REFERENCE_DATA_STALE_TIME,
    queryFn: async () => {
      const apiClient = new ConfigHttpClient({ authorization: await getToken() })
      const { data, error } = await apiClient.GET('/integrations', { params: { query: { type } } })
      throwIfApiError(error)
      return data
    },
  })
}
